
/**
 * Custom component for Romanza Dessert menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.3.0
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2022-05-25 (1.0.0) (jhoward)
 *    - Copy from Romanza_wineList.vue component.
 *    - Remove all BIN and price-type logic.
 *
 *  2023-04-17 (1.1.0) (jhoward)
 *    - Refactor <Romanza_dessert> component to use TypeScript.
 *    - <Romanza_dessert> section prop is required.
 *    - Refactor <Romanza_dessert> component to use helper computed properties.
 *    - Remove unused methods from <Romanza_dessert> component.
 *
 *    2023-08-23 (1.2.0) (jhoward)
 *      - Use <menu-version> in <Romanza_dessert>.
 *
 *    2023-11-08 (1.2.1) (jhoward)
 *      - Move <menu-tag> to the left of titles in <Romanza_dessert>.
 *      - Allow HTML in item.mi_description in <Romanza_dessert>.
 *
 *    2024-05-01 (1.2.2) (jhoward)
 *      - Add "Contains Nuts" <menu-tag> to "HOUSEMADE GELATO" subsection in <Romanza_dessert>.
 *
 *    2024-07-19 (1.2.3) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <romanza-dessert>.
 *
 *    2025-02-10 (1.3.0) (jhoward)
 *      - Add <menu-schedules> to the <Romanza_dessert> component if in admin view.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import RomanzaDessertSection from "./Romanza_dessert.vue";

export default defineComponent({
  components: {
    RomanzaDessertSection,
  },
  name: "Romanza_dessertWine",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
})
